import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { TopUpStackRoutes, TopUpStackScreenProps } from './type';
import { TopUpWebZeroScreen } from './TopUpWebZero.screen';
import { TopUpNativeZeroScreen } from './TopUpNativeZero.screen';

export const TopUpMain: React.FC<TopUpStackScreenProps<TopUpStackRoutes.Main>> = ({ navigation, route }) => {
  const { onLayout, onData, func, record, onReturnData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <TopUpNativeZeroScreen
        onClose={onGoBack}
        onLayout={onLayout}
        onData={onData}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
        record={record}
      />
    );
  }

  return (
    <TopUpWebZeroScreen
      onClose={closeModal}
      onLayout={onLayout}
      onData={onData}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
      record={record}
    />
  );
};
